<div
  class="annuler-multi-backdrop"
  (click)="onBackdropClick($event)"
  role="dialog"
  aria-modal="true"
  aria-labelledby="annuler-multi-title"
>
  <div class="annuler-multi-panel modal-panel" (click)="onPanelClick($event)">
    <div class="modal-header modal_head_title">
      <h3 id="annuler-multi-title">Annulation de tickets</h3>
      <button type="button" class="close-btn" (click)="onClose()" [disabled]="submitting">×</button>
    </div>

    <div class="modal-content annuler-multi-body">
      <ng-container *ngIf="step === 'list'">
        <p class="text-muted mb-3">
          Vérifiez les tickets à annuler. Les tickets terminés ou payés sont affichés en rouge
          (action réservée à l'administration).
        </p>
        <app-detaille-multi-selection-ticket
          [ticketIds]="ticketIds"
          [allowPaidCancel]="allowPaidCancel"
          (rowsChange)="onRowsChange($event)"
          (canProceedChange)="onCanProceedChange($event)"
        ></app-detaille-multi-selection-ticket>
      </ng-container>

      <ng-container *ngIf="step === 'confirm'">
        <div class="confirm-box">
          <h4 class="section-title-blue">Confirmer l'annulation</h4>
          <p>
            Vous allez annuler <strong>{{ rows.length }}</strong> ticket(s).
            Pour chaque ticket, un nouveau ticket compensatoire sera créé (quantités négatives).
          </p>
          <ul class="confirm-list">
            <li *ngFor="let row of rows">
              <span [class.text-danger]="row.requiresAdmin">{{ row.numero }}</span>
              — {{ row.entrepot }}
              <span *ngIf="row.kind === 'available'" class="badge badge-light-info ms-1">Initialisation</span>
              <span *ngIf="row.requiresAdmin" class="badge badge-light-danger ms-1">Payé / terminé</span>
            </li>
          </ul>
          <p class="small text-muted mb-0" *ngIf="hasAdminTickets">
            Tickets payés : montants négatifs et stock physique + disponible seront ajustés.
          </p>
          <p class="small text-muted mb-0" *ngIf="!hasAdminTickets">
            Initialisation : seul le stock disponible sera restauré (pas d'impact sur l'argent).
          </p>
        </div>
      </ng-container>
    </div>

    <div class="annuler-multi-footer">
      <ng-container *ngIf="step === 'list'">
        <button type="button" class="btn btn-outline-secondary" (click)="onClose()" [disabled]="submitting">
          Fermer
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onSuivant()"
          [disabled]="!canProceed || submitting || rows.length === 0"
        >
          Suivant
        </button>
      </ng-container>
      <ng-container *ngIf="step === 'confirm'">
        <button type="button" class="btn btn-outline-secondary" (click)="onRetour()" [disabled]="submitting">
          Retour
        </button>
        <button
          type="button"
          class="btn btn-danger"
          (click)="onConfirm()"
          [disabled]="submitting"
        >
          <span *ngIf="submitting" class="spinner-border spinner-border-sm me-1" role="status"></span>
          Confirmer l'annulation
        </button>
      </ng-container>
    </div>
  </div>
</div>
